import React from "react";
import InterestPageBooks from "./InterestPageBooks/InterestPageBooks";
import QAForm from "./QAForm";
import InterestPageHeader from "./InterestPageHeader";
import Meta from "@components/Meta";
import Entity from "@components/Entity";
import { useAppContext } from "@components/Provider";

const InterestPage = (props) => {
  const { data } = props;
  const post = data[0]?.Post?.post;
  const {
    siteId,
    data: siteSettingsData,
    subscriberCookie,
    isMobile,
    isTablet,
  } = useAppContext();
  const renderInterestPageComps = () => (
    <React.Fragment>
      <InterestPageHeader
        {...post.components.filter(
          (el) => el && el?.type === "interest-page-config"
        )[0]}
        siteID={props.siteId}
        bisacs={post.bisacs}
        isMobile={isMobile}
        title={post.title}
      />
      <InterestPageBooks
        {...props}
        books={[
          ...post.components.filter(
            (el) => el && el?.type === "interest-page-books"
          )[0]?.props,
        ]}
        newsletterProps={{
          ...post.components.filter((el) => el && el?.type === "newsletter-v2")[0]
            .props,
        }}
        isMobile={isMobile}
        isTablet={isTablet}
        subscriberCookie={subscriberCookie}
      />
      <QAForm
        {...post.components.filter((el) => el && el?.type === "qa-form")[0]}
        isMobile={isMobile}
        isTablet={isTablet}
      />
    </React.Fragment>
  );
  const { title: Title, description } = post.seo;
  const { SiteSettings } = siteSettingsData || {};
  const { site_name } = SiteSettings;
  const seoTitle = `${Title} - ${post.title} | ${site_name}`;
  const SEO_Data = {
    Title: seoTitle,
    Description: `${description} ${post.title}`,
  };
  return (
    <div className="interest-page">
      <Meta
        title={seoTitle}
        static={SEO_Data}
        pageType={Entity.STATIC}
        url={props.PageUrl}
        noIndex={post.seo.noIndex}
        isNewAppRouter={true}
      />
      {renderInterestPageComps()}
      <style jsx>
        {`
          // .interest-page {
          //   padding-top: ${!subscriberCookie && isMobile ? "15%" : "3%"};
          // }
          @media (max-width: 768px) {
            .interest-page {
              width: auto;
            }
          }
        `}
      </style>
    </div>
  );
};

export default InterestPage;
